import VideoPauseIcon from "./VideoPauseIcon";
export default VideoPauseIcon;
